import { MainLoadingView } from './ChartLoadingSkeleton';

export function ImportLoadingOverlay({ open }: { open: boolean }) {
  if (!open) return null;

  return (
    <div className="import-loading-overlay" role="status" aria-label="Importing watchlist">
      <MainLoadingView label="Importing watchlist" />
    </div>
  );
}
